import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../Images/logo.png"; // adjust path

export default function PageTransition() {
  const location = useLocation();
  const [show, setShow] = useState(true);

  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => setShow(false), 2000); // now 2s
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-white z-50 transition-opacity duration-700 ${
        show ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <img src={logo} alt="Logo" className="w-36 h-auto" />
    </div>
  );
}

